{
"catalog": {},
"plural": "(n != 1)"
}